







































































































































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';
import draggable from 'vuedraggable'
import {uuid} from "vue-uuid";
import IProduct from '@/components/icons/IProduct.vue'

const dialog = namespace('dialog')
const forms = namespace('forms')
const surveys = namespace('surveys')
const products = namespace('products')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    draggable,
    IProduct
  },
  name: "AddAnswersForm"
})
export default class AddAnswersForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options: any
  @surveys.Getter('survey') protected survey: any
  @products.Getter('products') protected products: any
  currentProduct: any = ''
  currentProducts: any = []
  answer: any = {
    value: '',
    includeQuestions: [],
    type: 'regular'
  }

  get getProducts(){
    return this.products
  }

  get productsForAnswers() {
    let arr = this.options.answers.map((el:any)=>{
      return el.productId
    })
    return this.getProducts.filter((el:any)=>{
      return !arr.includes(el._id)
    })
  }

  get getCurrentProducts(){
    return this.currentProducts
  }

  addAnswer() {
    this.options.answers.push({...this.answer,id:uuid.v1()});
    this.answer.value = ''
  }

  addProduct(val:any) {


    this.options.answers.push(
        {
          ...this.answer,
          id:uuid.v1(),
          value:this.products.filter((el:any)=>el._id == this.currentProduct)[0].title,
          productId:this.currentProduct
        }
        );
    this.currentProduct = ''
  }
  mounted(){
    this.currentProducts = this.options.answers.map((el:any)=>{return el.productId})||[]
  }

  save() {
    this.options.answers.forEach((answer: any, index: number) => {
      answer.order = index
      answer.sense = index
    })
    this.SetFullDialogShow(false)
  }


}
